import { ClientInvitation } from '../../../../hooks/api/useMyOrganizationClientInvitations';
import { ProfileListItem } from '../../../../primary-record-types/apiTypes/medicalProfileService';

export const findInviteProfile = (
    profiles: ProfileListItem[],
    invitation: ClientInvitation,
): ProfileListItem | null => {
    const areStringsEqual = (a: string | undefined | null, b: string | undefined | null) =>
        a && b && a.toLowerCase() === b.toLowerCase();

    return (
        profiles.find((profile) => {
            return (
                areStringsEqual(profile.firstName, invitation.clientFirstName) &&
                areStringsEqual(profile.lastName, invitation.clientLastName) &&
                areStringsEqual(profile.dob, invitation.clientDOB)
            );
        }) || null
    );
};
